import { render } from "./AcceptTerms.vue?vue&type=template&id=3a491bd1&scoped=true"
import script from "./AcceptTerms.vue?vue&type=script&lang=js"
export * from "./AcceptTerms.vue?vue&type=script&lang=js"

import "./AcceptTerms.vue?vue&type=style&index=0&id=3a491bd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a491bd1"]])

export default __exports__